import React from 'react'
import './dialog.css'

const Dialog = ({item, closeDialog, changeAdoptionStatus}) => {
  const cancelHandle = () => {
    closeDialog()
  }
  const confirmHandle = (itemId) => () => {
    changeAdoptionStatus({ id: itemId, status: 'rejected' })
    closeDialog()
  }
  return (
    <div className='dialog__container'>
      <div className='dialog__header'>
        <h2>Confirmar Exclusão</h2>
      </div>
      <div className='dialog__body'>
        {item.book
        ? <p>Você tem certeza que deseja excluir o livro <strong>{item.book.name}</strong> da lista de adoções da sua Escola?</p>
        : <p>Você tem certeza que deseja excluir o produto <strong>{item.product_detail.product_name}</strong> da lista de adoções da sua Escola?</p>
        }
      </div>
      <div className='dialog__footer'>
        <button className='button is-danger' onClick={confirmHandle(item.id)}>Confirmar</button>
        <button className='button is-light' onClick={cancelHandle}>Cancelar</button>
      </div>
    </div>
  )
}

export default Dialog



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js